import { Link } from "react-router-dom";
import { MEMBERSHIP_CATEGORIES } from "@/lib/brand";
import { Building2, MapPinned, Flag, Briefcase, School, Users, ArrowUpRight } from "lucide-react";

const ICONS = { Building2, MapPinned, Flag, Briefcase, School, Users };

export default function MembershipCategories() {
  return (
    <section data-testid="membership-categories" className="section-spacing bg-slate-50">
      <div className="nkf-container">
        <div className="max-w-3xl">
          <div className="text-[11px] uppercase tracking-[0.3em] text-nkf-red font-semibold">Membership Campaign</div>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-nkf-blue mt-2 leading-tight">
            Six Pillars of <span className="text-nkf-red">NKF Bharat</span>
          </h2>
          <p className="text-slate-600 mt-3 text-base leading-relaxed">
            Choose the category that represents you. Every registered member becomes part of the official national federation registry.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 mt-8 sm:mt-10 items-stretch">
          {MEMBERSHIP_CATEGORIES.map((c, idx) => {
            const Icon = ICONS[c.icon] || Building2;
            return (
              <Link
                key={c.key}
                to={`/memberships?cat=${c.key}`}
                data-testid={`membership-card-${c.key}`}
                className="federation-card group relative bg-nkf-blue text-white p-5 sm:p-6 md:p-7 rounded-md border border-nkf-blue/30 overflow-hidden flex flex-col h-full active:scale-[0.98]"
              >
                <div className="absolute -right-10 -top-10 w-32 h-32 rounded-full bg-nkf-gold/10 blur-2xl" />
                <div className="flex items-start justify-between gap-3">
                  <div className="h-11 w-11 rounded-md bg-white/10 border border-white/15 flex items-center justify-center">
                    <Icon className="h-5 w-5 text-nkf-gold" />
                  </div>
                  <div className="text-[11px] uppercase tracking-widest text-white/50">0{idx + 1}</div>
                </div>
                <h3 className="font-display text-lg sm:text-xl md:text-2xl mt-4 sm:mt-5 leading-snug min-h-[3.5rem]">{c.title}</h3>
                <ul className="mt-3 sm:mt-4 space-y-1.5 text-sm text-white/80 flex-1">
                  {c.items.map((it) => (
                    <li key={it} className="flex items-center gap-2">
                      <span className="h-1 w-1 rounded-full bg-nkf-gold" /> {it}
                    </li>
                  ))}
                </ul>
                <div className="flex items-center justify-between mt-6 pt-5 border-t border-white/10">
                  <span className="text-[11px] uppercase tracking-widest text-nkf-gold">Register</span>
                  <ArrowUpRight className="h-4 w-4 text-nkf-gold group-hover:rotate-45 transition-transform" />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
